// extracted by mini-css-extract-plugin
export default {"profileHeader":"styles_profileHeader__mAXAN"};